import { Component, Input } from "@angular/core"
import { UserService } from "../../services/user.service"

@Component({
    selector: "app-resource-poster",
    templateUrl: "./resource-poster.component.html",
    styleUrls: ["./resource-poster.component.less"],
})
export class ResourcePosterComponent {
    @Input() posterImage = null
    @Input() link = null
    @Input() alt = null
    @Input() duration = null
    @Input() hasSupportMaterials: boolean = false
    @Input() isInline: boolean = false
    @Input() gtmPrefix: string = ""
    @Input() absoluteUrl: string = ""
    placeholderImg: string = null

    constructor(public userService: UserService) {
        this.placeholderImg = require("../../../assets/placeholder-image.svg").default
    }

    getFormattedDuration(): string {
        return ResourcePosterComponent.formatDuration(this.duration)
    }

    static formatDuration(duration): string {
        if (!duration) {
            return null
        }
        if (duration.substring(0, 2) === "0:") {
            duration = duration.substring(2)
        }
        if (duration && duration[0] == "0") {
            duration = duration.substring(1)
        }
        return duration
    }

    getResourcePosterClass() {
        return `card-header-content gtm-${this.gtmPrefix}-resource-poster`
    }
}
